var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"markdown-editor"}},[_c('editor',{ref:"toastuiEditor",attrs:{"height":"200px","previewStyle":"tabs","options":_vm.editorOptions,"initialValue":_vm.currentText},on:{"change":_vm.onEditorChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }